/**
 * Channel through which an export run delivers the pending events to the partner.
 *
 * Mirrors the backend enum {@code com.mvs.backend.pd.enums.PdExportChannel} (persisted via
 * {@code @Enumerated(EnumType.ORDINAL)}; the value travels as the ordinal). Member names and order MUST match
 * the backend declaration exactly — append only, never insert, reorder or rename.
 */
export enum PdExportChannelEnum {
    MOCK,
    FILE_TRANSFER,
    NOTIFICATION,
}
